/**
 * i18n設定
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import jaJP from './locales/ja-JP.json';
import jaHiragana from './locales/ja-hiragana.json';
import en from './locales/en.json';

export const LANGUAGES = {
  JA_JP: 'ja-JP',
  JA_HIRAGANA: 'ja-hiragana',
  EN: 'en',
} as const;

export type Language = (typeof LANGUAGES)[keyof typeof LANGUAGES];

// localStorageから保存された言語設定を取得
const savedLanguage = localStorage.getItem('language') as Language | null;
const defaultLanguage = savedLanguage || LANGUAGES.JA_JP;

i18n.use(initReactI18next).init({
  resources: {
    [LANGUAGES.JA_JP]: { translation: jaJP },
    [LANGUAGES.JA_HIRAGANA]: { translation: jaHiragana },
    [LANGUAGES.EN]: { translation: en },
  },
  lng: defaultLanguage,
  fallbackLng: LANGUAGES.JA_JP,
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
